import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tagasi toote juurde

  <span style="color:#85c1dc;">**FI:**</span>
  Takaisin tuotteeseen

  <span style="color:#85c1dc;">**RU:**</span>
  Назад к товару
*/
/* @__NO_SIDE_EFFECTS__ */
const m564 = msg(
  mf`Tagasi toote juurde`,
  mf`Takaisin tuotteeseen`,
  mf`Назад к товару`,
)

export { m564 as 'w.saal.back-to-product' }